import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { v4 as uuid, } from 'uuid';

class AsyncActionButton extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      _id: uuid(),
    };
  }

  componentDidMount() {
    const { clickConsumer, } = this.props;
    const { _id, } = this.state;
    if (clickConsumer) {
      clickConsumer(() => {
        const element = document.getElementById(_id);
        if (element) {
          element.click();
        }
      });
    }
  }

  showButtonText() {
    const { isLoading, contents, } = this.props;
    if (isLoading) {
      return (
        <Spinner size="sm" animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      );
    }
    return contents;
  }

  render() {
    const {
      onClick, isLoading, loadingVariant, variant, className, clicked, style,
    } = this.props;
    const { _id, } = this.state;

    return (
      <Button
        id={_id}
        variant={isLoading ? loadingVariant : variant}
        disabled={isLoading || clicked}
        className={className}
        onClick={onClick}
        type="submit"
        style={style}
      >
        {this.showButtonText()}
      </Button>
    );
  }
}

AsyncActionButton.defaultProps = {
  isLoading: undefined,
  contents: undefined,
  loadingVariant: undefined,
  variant: undefined,
  className: undefined,
  clicked: undefined,
  clickConsumer: () => {},
  style: {},
};

AsyncActionButton.propTypes = {
  onClick: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool,
  loadingVariant: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  contents: PropTypes.string,
  clicked: PropTypes.bool,
  clickConsumer: PropTypes.func,
  style: PropTypes.object,
};

export default AsyncActionButton;
